// module_configs/pharmacy.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faPills, faUsersCog, faClock, faTriangleExclamation,
  faHourglassHalf, faBan, faGift, faTags, faTrashCan, faArrowTrendDown,
  faBoxesStacked, faSquarePlus, faPuzzlePiece, faFileExport, faFileImport,
  faUndoAlt, faExchangeAlt, faBuildingColumns, faWallet, faUserShield,
  faSlidersH, faSync, faHistory, faFileInvoiceDollar, faCoins
} from '@fortawesome/free-solid-svg-icons';

// Import Pharmacy components
import PharmacyDashboardHome from '.././module_pharmacy/pharmacy_DashHome';

import PharmacyAddCustomer from '.././module_pharmacy/pharmacy_customer';

import PharmacyCustomersListjsx from '.././module_pharmacy/pharmacy_customer_list';

import PharmacyAddSupplier from '.././module_pharmacy/pharmacy_Supplier';

import PharmacySupplierList from '.././module_pharmacy/pharmacy_SuppliersList';

import PharmacyAddEmployee from '.././module_pharmacy/pharmacy_employees';

import PharmacyEmployeeList from '.././module_pharmacy/pharmacy_employeelist';

import AddPharmacyItem from '.././module_pharmacy/pharmacy_items';

import PharmacyItemsList from '.././module_pharmacy/pharmacy_itemslist';

import PharmacyProduct from '.././module_pharmacy/pharmacy_Products';

import PharmacyProductsList from '.././module_pharmacy/pharmacy_ProductsList';

import PharmacyPurchases from '.././module_pharmacy/pharmacy_Purchases';

import PharmacyPurchaseList from '.././module_pharmacy/pharmacy_PurchaseList';

import PharmacyPurchasesbySupplier from '.././module_pharmacy/pharmacy_PurchasesbySupplier';

import PharmacyReturn from '.././module_pharmacy/pharmacy_Return';

import PharmacyReturnList from '.././module_pharmacy/pharmacy_ReturnList';

import PharmacySell from '.././module_pharmacy/pharmacy_Sell';

import PharmacySalesList from '.././module_pharmacy/pharmacy_SellList';

import PharmacyTransactionsManager from '.././module_pharmacy/pharmacy_transactions';

import PharmacyBarcode from '.././module_pharmacy/pharmacy_BarcodeGenerator';

import PharmacyBonusProducts from '.././module_pharmacy/pharmacy_BonusProducts';

import PharmacyExpiredProducts from '.././module_pharmacy/pharmacy_ExpiredProducts';

import PharmacySoonExpiredProducts from '.././module_pharmacy/pharmacy_ExpiringProducts';

import PharmacyOutProducts from '.././module_pharmacy/pharmacy_OutProducts';

import PharmacyLowStockProducts from '.././module_pharmacy/pharmacy_LowStock';

import PharmacyProductsDiscounts from '.././module_pharmacy/pharmacy_Discounts';

import PharmacyDisposedProducts from '.././module_pharmacy/pharmacy_ExposedProducts';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

export const pharmacyConfig = {
  moduleId: 'pharmacy',
  moduleName: 'Pharmacy',
  icon: faPills,
  description: 'Pharmacy & Medical Store Management System',
  
  // ===== ADDED: i18n configuration from solar =====
  i18n: {
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'ur', 'ps', 'ar', 'tr', 'fa', 'prs'],
    rtlLanguages: ['ur', 'ps', 'ar', 'fa', 'prs']
  },

  dashboardComponent: PharmacyDashboardHome,
  
  roles: {
    'admin_pharmacy': { level: 1, label: 'Admin', color: '#10b981' },
    'manager_pharmacy': { level: 2, label: 'Manager', color: '#059669' },
    'user_pharmacy': { level: 3, label: 'User', color: '#047857' },
    'viewer_pharmacy': { level: 4, label: 'Viewer', color: '#065f46' },
    'admin_pharmacytax': { level: 1, label: 'Admin (TAX)', color: '#34d399' },
    'manager_pharmacytax': { level: 2, label: 'Manager (TAX)', color: '#10b981' },
    'user_pharmacytax': { level: 3, label: 'User (TAX)', color: '#059669' },
    'viewer_pharmacytax': { level: 4, label: 'Viewer (TAX)', color: '#047857' }
  },
  
  // ===== UPDATED: Added more menuGroups matching solar structure =====
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'accounts', name: 'Accounts & Transactions', icon: faCoins, order: 4 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 5 }
  ],
  
  // ===== UPDATED: Added denied_shopid, allowed_shopid, aliases to all menus =====
  menus: [
    // ==================== SECTION 1: MANAGEMENT ====================
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: PharmacyDashboardHome,
      roles: ['all'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: PharmacyAddCustomer,
          icon: faUserPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: PharmacyCustomersListjsx,
          icon: faUsersLine,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: PharmacyAddSupplier,
          icon: faUserTie,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: PharmacySupplierList,
          icon: faBuildingUser,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: PharmacyAddEmployee,
          icon: faUserPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: PharmacyEmployeeList,
          icon: faIdCard,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 2: INVENTORY & STOCK ====================
    {
      id: 'items',
      label: 'Items',
      icon: faPuzzlePiece,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'inventory',
      position: 0,
      submenus: [
        {
          id: 'newitem',
          label: 'Add Item',
          component: AddPharmacyItem,
          icon: faSquarePlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'itemslist',
          label: 'Items List',
          component: PharmacyItemsList,
          icon: faListAlt,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock Management',
      icon: faBoxesStacked,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'inventory',
      position: 1,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: PharmacyProduct,
          icon: faSquarePlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: PharmacyProductsList,
          icon: faClipboardList,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'discounts',
          label: 'TP%, Extra%',
          component: PharmacyProductsDiscounts,
          icon: faTags,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'bonusproducts',
          label: 'Bonus Stock',
          component: PharmacyBonusProducts,
          icon: faGift,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'lowstock',
          label: 'Low Stock',
          component: PharmacyLowStockProducts,
          icon: faArrowTrendDown,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'outofstock',
          label: 'Out of Stock',
          component: PharmacyOutProducts,
          icon: faBan,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'expiringproducts',
          label: 'Expiring Stock',
          component: PharmacySoonExpiredProducts,
          icon: faHourglassHalf,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'expiredproducts',
          label: 'Expired Stock',
          component: PharmacyExpiredProducts,
          icon: faTriangleExclamation,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'disposedstock',
          label: 'Disposed Stock',
          component: PharmacyDisposedProducts,
          icon: faTrashCan,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase Management',
      icon: faTruckFast,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'inventory',
      position: 2,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: PharmacyPurchases,
          icon: faCartPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: PharmacyPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'purchasesbysupplier',
          label: 'Supplier-wise',
          component: PharmacyPurchasesbySupplier,
          icon: faBuilding,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'inventory',
      position: 3,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: PharmacyBarcode,
          icon: faPrint,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 3: SALES & RETURNS ====================
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'sales',
      position: 0,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: PharmacySell,
          icon: faCartPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: PharmacySalesList,
          icon: faClipboardList,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'returns',
      label: 'Sales Returns',
      aliases: ['sale_return', 'sales_return', 'salereturn', 'salesreturns', 'pharmacy_return'],
      icon: faFileExport,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'sales',
      position: 1,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          aliases: ['add_sale_return', 'new_sale_return', 'pharmacy_return'],
          component: PharmacyReturn,
          icon: faRotateLeft,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'returnlist',
          label: 'Return List',
          aliases: ['sale_return_list', 'sales_return_list', 'pharmacy_returnlist'],
          component: PharmacyReturnList,
          icon: faListCheck,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: faArrowRightArrowLeft,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'sales',
      position: 2,
      submenus: [
        {
          id: 'transactionsmanager',
          label: 'All Transactions',
          component: PharmacyTransactionsManager,
          icon: faExchangeAlt,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 4: SYSTEM SETTINGS ====================
    {
      id: 'settings',
      label: 'System Settings',
      icon: faSlidersH,
      component: RootUsers,
      roles: ['admin_pharmacy', 'admin_pharmacytax'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'system',
      position: 0,
      submenus: [
        {
          id: 'users',
          label: 'User Management',
          component: RootUsers,
          icon: faUserShield,
          roles: ['admin_pharmacy', 'admin_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'systemupdates',
          label: 'Notifications Center',
          component: MessageSystem,
          icon: faBullhorn,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '2,100' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 567 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 134 },
    { id: 'pending', label: 'Expiring Soon', icon: 'faClock', value: 23 }
  ],

  // ===== ADDED/COMPLETELY REWRITTEN: Full shortcuts with menuId/submenuId and actions =====
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard', menuId: 'dashboard' },

    { key: 'Alt + C', description: 'Customers', menuId: 'customers' },
    { key: 'Alt + Shift + A', description: 'Add Customer', menuId: 'customers', submenuId: 'addcustomer' },
    { key: 'Alt + Shift + B', description: 'Customer List', menuId: 'customers', submenuId: 'customerlist' },

    { key: 'Alt + S', description: 'Suppliers', menuId: 'suppliers' },
    { key: 'Alt + Shift + C', description: 'Add Supplier', menuId: 'suppliers', submenuId: 'addsupplier' },
    { key: 'Alt + Shift + D', description: 'Supplier List', menuId: 'suppliers', submenuId: 'supplierlist' },

    { key: 'Alt + E', description: 'Employees', menuId: 'employees' },
    { key: 'Alt + Shift + G', description: 'Add Employee', menuId: 'employees', submenuId: 'addemployees' },
    { key: 'Alt + Shift + H', description: 'Employees List', menuId: 'employees', submenuId: 'employeeslist' },

    { key: 'Alt + I', description: 'Items', menuId: 'items' },
    { key: 'Alt + Shift + K', description: 'Add Item', menuId: 'items', submenuId: 'newitem' },
    { key: 'Alt + Shift + L', description: 'Items List', menuId: 'items', submenuId: 'itemslist' },

    { key: 'Alt + K', description: 'Stock Management', menuId: 'stock' },
    { key: 'Alt + Shift + Q', description: 'Add Stock', menuId: 'stock', submenuId: 'addstock' },
    { key: 'Alt + Shift + R', description: 'Stock List', menuId: 'stock', submenuId: 'stocklist' },
    { key: 'Alt + Shift + U', description: 'Discounts', menuId: 'stock', submenuId: 'discounts' },
    { key: 'Alt + Shift + V', description: 'Bonus Stock', menuId: 'stock', submenuId: 'bonusproducts' },
    { key: 'Alt + Shift + W', description: 'Low Stock', menuId: 'stock', submenuId: 'lowstock' },
    { key: 'Alt + Shift + X', description: 'Out of Stock', menuId: 'stock', submenuId: 'outofstock' },
    { key: 'Alt + Shift + Y', description: 'Expiring Stock', menuId: 'stock', submenuId: 'expiringproducts' },
    { key: 'Alt + Shift + Z', description: 'Expired Stock', menuId: 'stock', submenuId: 'expiredproducts' },
    { key: 'Alt + Shift + 0', description: 'Disposed Stock', menuId: 'stock', submenuId: 'disposedstock' },

    { key: 'Alt + U', description: 'Purchase Management', menuId: 'purchases' },
    { key: 'Alt + Shift + 1', description: 'New Purchase', menuId: 'purchases', submenuId: 'addpurchase' },
    { key: 'Alt + Shift + 2', description: 'Purchases List', menuId: 'purchases', submenuId: 'purchaselist' },
    { key: 'Alt + Shift + 3', description: 'Supplier-wise Purchases', menuId: 'purchases', submenuId: 'purchasesbysupplier' },

    { key: 'Alt + B', description: 'Barcodes', menuId: 'barcode' },
    { key: 'Alt + Shift + 4', description: 'Barcode Printing', menuId: 'barcode', submenuId: 'barcodeprinting' },

    { key: 'Alt + A', description: 'Sales', menuId: 'sales' },
    { key: 'Alt + Shift + 5', description: 'New Sale', menuId: 'sales', submenuId: 'addsale' },
    { key: 'Alt + Shift + 6', description: 'Sales List', menuId: 'sales', submenuId: 'saleslist' },

    { key: 'Alt + R', description: 'Sales Returns', menuId: 'returns' },
    { key: 'Alt + Shift + 7', description: 'New Sales Return', menuId: 'returns', submenuId: 'addreturn' },
    { key: 'Alt + Shift + 8', description: 'Sales Return List', menuId: 'returns', submenuId: 'returnlist' },

    { key: 'Alt + M', description: 'Transactions', menuId: 'transactions' },
    { key: 'Alt + Shift + 9', description: 'All Transactions', menuId: 'transactions', submenuId: 'transactionsmanager' },

    { key: 'Alt + O', description: 'System Settings', menuId: 'settings' },
    { key: 'Alt + Shift + N', description: 'User Management', menuId: 'settings', submenuId: 'users' },
    { key: 'Alt + Shift + P', description: 'Notifications Center', menuId: 'settings', submenuId: 'systemupdates' },

    // ===== ADDED: Global action shortcuts from solar =====
    { key: 'Escape', description: 'Hide or show sidebar', action: 'toggleSidebar' },
    { key: 'Alt + J', description: 'Open or close shop switcher', action: 'toggleShopSwitcher' },
    { key: 'Alt + X', description: 'Change to next theme color', action: 'cycleTheme' },
    { key: 'Alt + Z', description: 'Switch dark or light mode', action: 'toggleDarkMode' },
    { key: 'Alt + Q', description: 'Focus menu search', action: 'focusSearch' },
    { key: 'Alt + Y', description: 'Change to next language', action: 'cycleLanguage' },
    { key: 'Alt + H', description: 'Show or hide keyboard shortcuts', action: 'toggleShortcuts' }
  ]
};